document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -30% 0px', // bottom margin so it triggers earlier
    threshold: 0.5 // at least 50% must be visible
  };

  const sections = document.querySelectorAll('[id^="faq-group"], [id]:has(.accordion)');
  const links = document.querySelectorAll('.faq-title');

  const observer = new IntersectionObserver((entries) => {
    // Find the entry with the largest visible area
    const visibleEntries = entries
      .filter(entry => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

    if (visibleEntries.length > 0) {
      const id = visibleEntries[0].target.getAttribute('id');

      links.forEach(link => {
        link.classList.toggle('active', link.dataset.target === id);
      });
    }
  }, observerOptions);

  sections.forEach(section => {
    observer.observe(section);
  });
});
